import { AuthInsuranceClients, AuthUnits } from '@/utils/enums/validUnitsEnum/insuranceAuthorizerEnum.js';

export default (insuranceCode, currentUnitId) => {
  const insuranceClientsValues = Object.values(AuthInsuranceClients);
  const unitValues = Object.values(AuthUnits);
  const currentUnit = (typeof currentUnitId === 'string')
    ? currentUnitId
    : currentUnitId.toString();

  // Checks if insurance client is valid for authorization
  const insuranceCodeCheck = insuranceClientsValues.find((clientValue) => clientValue.code === insuranceCode);

  // Checks if it's an insurance authorizer active unit
  const unitCheck = unitValues.find((unit) => {
    return unit.unitId === currentUnit;
  });

  return !!(insuranceCodeCheck && unitCheck);
};
